<div class="section-wrapper" *ngIf="hasCreditCardOnFile && isUserOnTrialBasedBilling || !isUserOnTrialBasedBilling">
  <div class="section-header">
    <ng-icon class="section-icon" [name]="'heroCreditCard'" [size]="'24px'" [color]="'#822AC6'"
      [strokeWidth]="'2'"></ng-icon>
    <div class="section-heading">
      {{ 'ACCOUNT.BILLING.USAGE' | translate }}
    </div>
  </div>
  <div class="section-info alert-info justify-content-between" *ngIf="isConfirmingCharge">
    <div class="d-flex align-items-center">
      <img class="icon" [src]="'assets/images/alert-icon-with-background.svg'">
      <span class="text">{{ 'ACCOUNT.BILLING.CONFIRMING_CHARGE' | translate }}</span>
    </div>
  </div>
  <div class="section-info alert-info justify-content-between" *ngIf="isPendingApproval && !isConfirmingCharge">
    <div class="d-flex align-items-center">
      <img class="icon" [src]="'assets/images/alert-icon-with-background.svg'">
      <span class="text">{{ (isAppleBillingProvider ? 'ACCOUNT.BILLING.APPLE_PENDING_APPROVAL' : 'ACCOUNT.BILLING.PENDING_APPROVAL_MESSAGE') | translate }}</span>
    </div>
  </div>
  <div class="section-info alert-info justify-content-between"
    *ngIf="isSubscriptionPastDue && !isExternalBillingProvider">
    <div class="d-flex align-items-center">
      <img class="icon" [src]="'assets/images/alert-icon-with-background.svg'">
      <span class="text">There is an issue with your payment. Please update your payment details.</span><span
        *ngIf="hasPaymentFailedTriggered" class="ml-1 action" (click)="refreshPaymentState()">{{'COMMON.REFRESH_STATUS'
        | translate}}</span>
    </div>
    <rosie-button [customClass]="'btn slim dark'" (click)="redirectToBillingPortal()" class="d-block"
      [translationKey]="'ACCOUNT.BILLING.MANAGE_BILLING'"
      [iconSuffixConfig]="{name: 'heroArrowUpRight', size: '16px', color: '#C1BBCA', strokeWidth: '2'}"></rosie-button>
  </div>
  <div class="section-content-wrapper" *ngIf="isCanceled && !isExternalBillingProvider">
    <rosie-alert [message]="'You don\'t have an active subscription. Select a plan below to get started.'"
      [type]="'error-info'" class="d-block" [customClass]="'my-0 justify-content-start'"></rosie-alert>
  </div>
  <div class="section-content-wrapper resubscribe-external" *ngIf="isCanceled && isExternalBillingProvider">
    <rosie-alert [message]="canceledProviderMessage | translate" [type]="'error-info'"
      class="d-block" [customClass]="'my-0 justify-content-start'"></rosie-alert>
    <rosie-button *ngIf="isAppleBillingProvider" class="d-block mt-2" (click)="openRosieApp()"
      [translationKey]="'ACCOUNT.BILLING.OPEN_ROSIE_APP'" [customClass]="'btn btn-primary slim'"
      [iconSuffixConfig]="{name: 'heroArrowUpRight', size: '16px', color: '#ffffff', strokeWidth: '2'}"></rosie-button>
    <ng-container *ngIf="isShopifyBillingProvider">
      <rosie-button *ngIf="!shopifyReinstallRequired" class="d-block mt-2" (click)="goToShopifyResubscribe()"
        [translationKey]="'ACCOUNT.BILLING.GO_TO_SHOPIFY'" [customClass]="'btn btn-primary slim'"
        [iconSuffixConfig]="{name: 'heroArrowUpRight', size: '16px', color: '#ffffff', strokeWidth: '2'}"></rosie-button>
      <ng-container *ngIf="shopifyReinstallRequired">
        <rosie-alert [message]="'ACCOUNT.BILLING.SHOPIFY_REINSTALL_MESSAGE' | translate" [type]="'error-info'"
          class="d-block mt-2" [customClass]="'my-0 justify-content-start'"></rosie-alert>
        <rosie-button class="d-block mt-2" (click)="reinstallFromAppStore()"
          [translationKey]="'ACCOUNT.BILLING.REINSTALL_FROM_APP_STORE'" [customClass]="'btn btn-primary slim'"
          [iconSuffixConfig]="{name: 'heroArrowUpRight', size: '16px', color: '#ffffff', strokeWidth: '2'}"></rosie-button>
      </ng-container>
    </ng-container>
  </div>
  <div class="section-content-wrapper p-0" *ngIf="!isCanceled">
    <div class="billing-overview-section">
      <div class="plans-and-wt-column">
        <div class="plans-row">
          <div class="current-plan-section" *ngIf="subscriptionDetails?.currentPlan">
            <div class="d-flex align-items-center justify-content-between">
              <div class="billing-cycle">
                <span
                  *ngIf="subscriptionDetails.currentPlan.billingCycleStart && subscriptionDetails.currentPlan.billingCycleEnd">
                  {{ [subscriptionDetails.currentPlan.billingCycleStart,
                  subscriptionDetails.currentPlan.billingCycleEnd]
                  |
                  billingDateFormat }}</span>
              </div>
              <div class="badge current">CURRENT</div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="label">Plan</div>
              <div class="value">{{ subscriptionDetails.currentPlan.planName }}

              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between" *ngIf="!isTrialing">
              <div class="label">Frequency</div>
              <div class="value">{{ subscriptionDetails.currentPlan.planFrequency === 'year' ? 'Annually' : 'Monthly' }}
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="label">Price</div>
              <div class="value" *ngIf="!isTrialing">
                <ng-container
                  *ngIf="subscriptionDetails.currentPlan.originalPlanCost !== subscriptionDetails.currentPlan.discountedPlanCost">
                  <span class="text-decoration-line-through me-2">{{ subscriptionDetails.currentPlan.originalPlanCost |
                    billingPriceFormat }}</span>
                </ng-container>
                {{ subscriptionDetails.currentPlan.discountedPlanCost | billingPriceFormat }}
              </div>
              <div class="value" *ngIf="isTrialing">Free</div>
            </div>
            <div class="d-flex align-items-center justify-content-between"
              *ngIf="isTrialing && subscriptionDetails.currentPlan.billingCycleEnd">
              <div class="label">Trial Ends</div>
              <div class="value">{{ subscriptionDetails.currentPlan.billingCycleEnd | billingDateFormat:true }}
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between"
              *ngIf="isTrialing && subscriptionDetails?.upcomingPlan && isShopifyBillingProvider">
              <div class="label">After Trial</div>
              <div class="value">{{ subscriptionDetails.upcomingPlan.planName }} — {{ subscriptionDetails.upcomingPlan.discountedPlanCost | billingPriceFormat }}/{{ subscriptionDetails.upcomingPlan.planFrequency === 'year' ? 'year' : 'month' }}
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between"
              *ngIf="subscriptionDetails.currentPlan.couponsApplied?.length && !isExternalBillingProvider">
              <div class="label"></div>
              <div class="value d-flex align-items-center">
                <ng-icon [name]="'heroTagSolid'" [size]="'20px'" class="mr-sm" [color]="'#A89FB3'"></ng-icon>
                <ng-container *ngFor="let coupon of subscriptionDetails.currentPlan.couponsApplied; let last = last">
                  {{ getCouponDisplayText(coupon) }}<ng-container *ngIf="!last">, </ng-container>
                </ng-container>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between" *ngIf="!isUserOnBillingV4">
              <div class="label d-flex align-items-center">Calls<img class="icon question ml-sm"
                  [src]="'assets/images/info-icon-tooltip.svg'"
                  [ngbTooltip]="'Calls answered by Rosie during this billing cycle'" tooltipClass="tooltip-wrapper">
              </div>
              <div class="value">{{ totalNumCallsBillingPeriod }}</div>
            </div>
          </div>
          <div class="upcoming-plan-section" *ngIf="subscriptionDetails?.upcomingPlan">
            <div class="d-flex align-items-center justify-content-between">
              <div class="billing-cycle">
                {{ [subscriptionDetails.upcomingPlan.billingCycleStart,
                subscriptionDetails.upcomingPlan.billingCycleEnd]
                | billingDateFormat }}
              </div>
              <div class="badge upcoming">UPCOMING</div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="label">Plan</div>
              <div class="value">{{ subscriptionDetails.upcomingPlan.planName }}</div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="label">Frequency</div>
              <div class="value">{{ subscriptionDetails.upcomingPlan.planFrequency === 'year' ? 'Annually' : 'Monthly'
                }}
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="label">Price</div>
              <div class="value">
                <ng-container
                  *ngIf="subscriptionDetails.upcomingPlan.originalPlanCost !== subscriptionDetails.upcomingPlan.discountedPlanCost">
                  <span class="striked-through">{{ subscriptionDetails.upcomingPlan.originalPlanCost |
                    billingPriceFormat }}</span>
                </ng-container>
                {{ subscriptionDetails.upcomingPlan.discountedPlanCost | billingPriceFormat }}
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between"
              *ngIf="subscriptionDetails.upcomingPlan.couponsApplied?.length && !isExternalBillingProvider">
              <div class="label"></div>
              <div class="value d-flex align-items-center">
                <ng-icon [name]="'heroTagSolid'" [size]="'20px'" class="mr-sm" [color]="'#A89FB3'"></ng-icon>
                <ng-container *ngFor="let coupon of subscriptionDetails.upcomingPlan.couponsApplied; let last = last">
                  {{ getCouponDisplayText(coupon) }}<ng-container *ngIf="!last">, </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="set-to-cancel-section" *ngIf="isCanceledAtEndOfBillingCycle">
            <div class="d-flex align-items-center justify-content-between">
              <div class="billing-cycle">
                {{ subscriptionDetails.currentPlan.billingCycleEnd | billingDateFormat }}
              </div>
              <div class="badge canceled">SET TO CANCEL</div>
            </div>
            <rosie-alert [message]="'Rosie will stop answering calls after the cancellation date.' | translate"
              [customIcon]="'alert-info-icon-light.svg'" [type]="'info'" class="d-block"
              [customClass]="'mb-0'"></rosie-alert>
            <rosie-button *ngIf="!isExternalBillingProvider" (click)="resubscribe()" [translationKey]="'Reactivate Plan'"
              [customClass]="'btn btn-primary slim'">
            </rosie-button>
          </div>
        </div>
        <!-- Website Texting Add-on Section -->
        <div class="wt-addon-section" *ngIf="subscriptionDetails?.currentPlan">
          <div class="d-flex align-items-center justify-content-between" *ngIf="!isWtSetToCancel">
            <div class="wt-heading">Website Texting</div>
            <div class="badge" [ngClass]="{
              'wt-enabled': isWtEnabled,
              'wt-disabled': isWtDisabled,
              'wt-in-progress': isWtInProgress
            }">{{ isWtInProgress ? 'IN PROGRESS' : (isWtEnabled ? 'ENABLED' : 'DISABLED') }}</div>
          </div>
          <!-- Apple-managed State -->
          <ng-container *ngIf="isAppleBillingProvider">
            <div class="label">{{ 'ACCOUNT.BILLING.APPLE_WT_MANAGED' | translate }}</div>
          </ng-container>
          <!-- Disabled State -->
          <ng-container *ngIf="isWtDisabled && !isAppleBillingProvider">
            <span [ngbTooltip]="isPaused ? ('ACCOUNT.BILLING.WT_PAUSED_TOOLTIP' | translate) : ''"
              [tooltipClass]="'tooltip-wrapper'" container="body">
              <rosie-button [customClass]="'action text-sm'" [translationKey]="'Enable Website Texting'"
                [disabled]="isPaused" (click)="openWtSubscribeModal()">
              </rosie-button>
            </span>
          </ng-container>
          <!-- Enabled State (Stripe & Shopify — Apple users see managed message above) -->
          <ng-container *ngIf="isWtEnabled && !isAppleBillingProvider">
            <div class="wt-price-section">
              <div class="d-flex align-items-center justify-content-between">
                <div class="label">Price</div>
                <div class="value">
                  <ng-container
                    *ngIf="wtSubscription?.discountedPrice != null && wtSubscription?.discountedPrice !== wtSubscription?.price">
                    <span class="text-decoration-line-through me-2" style="opacity: 0.5">${{ wtSubscription?.price
                      }}</span>
                  </ng-container>
                  ${{ wtSubscription?.discountedPrice != null && wtSubscription?.discountedPrice !==
                  wtSubscription?.price
                  ? wtSubscription?.discountedPrice : wtSubscription?.price }}
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-end gap-2"
                *ngIf="wtSubscription?.couponsApplied?.length">
                <div class="value d-flex align-items-center">
                  <ng-icon [name]="'heroTagSolid'" [size]="'20px'" class="mr-sm" [color]="'#A89FB3'"></ng-icon>
                  $50 credit applied
                </div>
              </div>
            </div>
            <div class="d-flex align-items-start justify-content-between" *ngIf="wtSubscription?.nextBillingDate">
              <div class="label">Next Billing Date</div>
              <div class="wt-billing-value-col">
                <div class="value">{{ wtSubscription?.nextBillingDate | dateFormat:false:true }}</div>
                <div class="wt-cancel-link" (click)="wtCancelModalRef?.open()">Cancel Website Texting</div>
              </div>
            </div>
          </ng-container>
          <!-- Set to Cancel State (Stripe & Shopify) -->
          <ng-container *ngIf="isWtSetToCancel && !isAppleBillingProvider">
            <div class="wt-set-to-cancel-layout">
              <!-- Left column: heading + price/coupon/billing details -->
              <div class="wt-cancel-left">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="wt-heading">Website Texting</div>
                  <div class="badge wt-enabled">ENABLED</div>
                </div>
                <div class="wt-price-section">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="label">Price</div>
                    <div class="value">
                      <ng-container
                        *ngIf="wtSubscription?.discountedPrice != null && wtSubscription?.discountedPrice !== wtSubscription?.price">
                        <span class="text-decoration-line-through me-2" style="opacity: 0.5">${{ wtSubscription?.price
                          }}</span>
                      </ng-container>
                      ${{ wtSubscription?.discountedPrice != null && wtSubscription?.discountedPrice !==
                      wtSubscription?.price ? wtSubscription?.discountedPrice : wtSubscription?.price }}
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-end gap-2"
                    *ngIf="wtSubscription?.couponsApplied?.length > 0">
                    <div class="value d-flex align-items-center">
                      <ng-icon [name]="'heroTagSolid'" [size]="'20px'" class="mr-sm" [color]="'#A89FB3'"></ng-icon>
                      $50 credit applied
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <div class="label">Next Billing Date</div>
                  <div class="value">None</div>
                </div>
              </div>
              <!-- Right column: cancellation info -->
              <div class="wt-cancel-right">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="wt-cancel-date" *ngIf="wtSubscription?.cancellationDate">
                    {{ wtSubscription?.cancellationDate | dateFormat:false:true }}
                  </div>
                  <div class="badge canceled">SET TO CANCEL</div>
                </div>
                <rosie-alert [message]="'You will lose access to Website Texting on the cancellation date.'"
                  [customIcon]="'alert-info-icon-light.svg'" [type]="'info'" class="d-block"
                  [customClass]="'mb-0'"></rosie-alert>
                <span [ngbTooltip]="isPaused ? ('ACCOUNT.BILLING.WT_PAUSED_TOOLTIP' | translate) : ''"
                  [tooltipClass]="'tooltip-wrapper'" container="body">
                  <rosie-button (click)="reactivateWt()" [translationKey]="'Reactivate Add-On'"
                    [disabled]="isPaused" [customClass]="'btn btn-primary slim wt-reactivate-btn'">
                  </rosie-button>
                </span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="manage-billing-section" *ngIf="isExternalBillingProvider">
        <div class="heading">
          {{ providerManagedMessage | translate }}
        </div>
      </div>
      <div class="manage-billing-section" *ngIf="!isExternalBillingProvider">
        <div class="heading">
          Payment Details & Invoices
        </div>
        <div class="subheading">
          Find account related payment details and historical invoices here.
        </div>
        <div class="manage-payment-details-actions">
          <rosie-button (click)="redirectToBillingPortal()" class="d-block redirect-to-billing-portal-button full-row"
            [iconSuffixConfig]="{name: 'heroArrowUpRight', size: '16px', color: '#9487A0', strokeWidth: '2'}"
            [customClass]="'transparent narrow slim text-sm btn-block'" [translationKey]="'Manage Details'">
          </rosie-button>
          <div class="cancel-pause-row" *ngIf="!isInCancelState">
            <rosie-button (click)="cancelSubscription()"
              [attr.data-subscription-id]="subscription.subscriptionData?.externalSubscriptionId"
              class="d-block cancel-subscription-button" [customClass]="'secondary text-sm'"
              [translationKey]="'ACCOUNT.BILLING.CANCEL_SUBSCRIPTION'">
            </rosie-button>
            <rosie-button (click)="isPaused ? unpauseSubscription() : openPauseModal()"
              *ngIf="!isExternalBillingProvider && !isTrialing"
              class="d-block pause-subscription-button"
              [inProgress]="isUnpausing"
              [customClass]="isPaused ? 'slim text-sm' : 'secondary text-sm'"
              [translationKey]="isPaused ? 'ACCOUNT.BILLING.UNPAUSE' : 'ACCOUNT.BILLING.PAUSE'">
            </rosie-button>
          </div>
        </div>
      </div>
    </div>
    <div class="billing-stats" *ngIf="isTrialing && !isUserOn7DayFreeTrialVersion && !isUserOnBillingV4">
      <div class="section-column-box w-100 d-flex align-items-center free-trial-stats">
        <img *ngIf="!hasCreditCardOnFile && isUserOnFreeMinutesBillingVersion" class="lock-account-icon"
          [src]="'assets/images/lock-account-icon.svg'">
        <div class="w-100">
          <div class="d-flex align-items-center justify-content-between free-trial-minutes-content-wrapper">
            <div class="column-label d-flex align-items-center free-trial-minutes-label">{{
              'ACCOUNT.BILLING.FREE_TRIAL_MINUTES_REMAINING' |
              translate }}<span *ngIf="!hasCreditCardOnFile && isUserOnFreeMinutesBillingVersion"
                class="column-disclaimer">
                <span class="slash">/</span>
                <span class="text-underline pointer" (click)="subscribe()">Activate Free Trial</span> to
                unlock</span>
            </div>
            <div class="column-content free-trial-minutes-value">{{minutesRemaining}} / {{minutesIncluded}}</div>
          </div>
          <ngb-progressbar class="bar thin"
            [ngClass]="{'alert': !hasCreditCardOnFile && isUserOnFreeMinutesBillingVersion}" type="success"
            [value]="(minutesIncluded - minutesUsed)" [max]="minutesIncluded" />
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Usage Section (V4) -->
<div class="section-wrapper"
  *ngIf="mockUsage || (isUserOnBillingV4 && hasCreditCardOnFile && !isCanceled && !isTrialing)">
  <div class="section-header">
    <ng-icon class="section-icon" [name]="'heroWallet'" [size]="'24px'" [color]="'#822AC6'"
      [strokeWidth]="'2'"></ng-icon>
    <div class="section-heading">Usage</div>
  </div>
  <div class="section-content-wrapper">
    <div class="v4-usage-section">
      <!-- Calls Usage -->
      <div class="v4-usage-card">
        <div class="v4-usage-card-header">
          <div class="v4-usage-icon-circle">
            <ng-icon [name]="'heroPhoneArrowUpRight'" [size]="'20px'" [color]="'#822AC6'" [strokeWidth]="'2'"></ng-icon>
          </div>
          <div>
            <div class="v4-usage-card-title">Calls</div>
            <div class="v4-usage-auto-upgrade">You'll be auto upgraded to the next plan when you exceed your current
              plan's minute limit.</div>
          </div>
        </div>
        <div class="v4-usage-bar-area">
          <div class="v4-usage-bar-section">
            <div class="v4-usage-bar-label">
              <span class="v4-usage-bar-label-text">Minutes Used</span>
              <span><span class="v4-usage-value-used">{{ callMinutesUsed }}</span><span class="v4-usage-value-total"> /
                  {{ callMinutesIncluded }}</span></span>
            </div>
            <div class="v4-usage-bar">
              <div class="v4-usage-bar-fill" [style.width.%]="minutesUsedPercent"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Texting Usage (when WT enabled) -->
      <ng-container *ngIf="mockUsage || isWtEnabled || isWtSetToCancel || isWtInProgress">
        <ng-container *ngTemplateOutlet="wtUsageCard"></ng-container>
      </ng-container>
    </div>
  </div>
</div>

<!-- WT Usage for non-V4 billing versions -->
<div class="section-wrapper"
  *ngIf="!isUserOnBillingV4 && hasCreditCardOnFile && !isCanceled && (isWtEnabled || isWtSetToCancel || isWtInProgress)">
  <div class="section-header">
    <ng-icon class="section-icon" [name]="'heroWallet'" [size]="'24px'" [color]="'#822AC6'"
      [strokeWidth]="'2'"></ng-icon>
    <div class="section-heading">Usage</div>
  </div>
  <div class="section-content-wrapper">
    <div class="v4-usage-section">
      <ng-container *ngTemplateOutlet="wtUsageCard"></ng-container>
    </div>
  </div>
</div>

<!-- WT Usage Card Template -->
<ng-template #wtUsageCard>
  <div class="v4-usage-card">
    <div class="v4-usage-card-header">
      <div class="v4-usage-icon-circle">
        <ng-icon [name]="'heroChatBubbleLeftRight'" [size]="'20px'" [color]="'#822AC6'" [strokeWidth]="'2'"></ng-icon>
      </div>
      <div>
        <div class="v4-usage-card-title">Website Texting</div>
        <div class="v4-usage-auto-upgrade" *ngIf="wtUsage?.billingResetDate">
          Resets on next billing date: {{ wtUsage?.billingResetDate | dateFormat:false:true }}
        </div>
      </div>
    </div>
    <div class="v4-usage-bar-area">
      <div class="v4-usage-bar-section">
        <div class="v4-usage-bar-label">
          <span class="v4-usage-bar-label-text">Included Conversations</span>
          <span><span class="v4-usage-value-used">{{ wtConversationsUsed }}</span><span class="v4-usage-value-total"> /
              {{ wtConversationsIncluded }}</span></span>
        </div>
        <div class="v4-usage-bar">
          <div class="v4-usage-bar-fill" [style.width.%]="wtIncludedPercent"></div>
        </div>
      </div>
      <div class="v4-usage-bar-section">
        <div class="v4-usage-bar-label">
          <span class="v4-usage-bar-label-text d-flex align-items-center gap-1">
            Overage Conversations
            <ng-icon [name]="'heroInformationCircleSolid'" [size]="'16px'" [color]="'#C1BBCA'"
              [ngbTooltip]="'You will be billed for overages at the end of your billing cycle.'"
              tooltipClass="tooltip-wrapper"></ng-icon>
          </span>
          <span><span class="v4-usage-value-used">{{ wtOverageConversations || 0 }}</span><span
              class="v4-usage-value-total"><ng-container *ngIf="wtOverageConversations > 0"> (${{ wtOverageConversations
                *
                (wtUsage?.overageRate || 1) | number:'1.2-2' }})</ng-container><ng-container
                *ngIf="!wtOverageConversations"> at $0.00</ng-container></span></span>
        </div>
        <div class="v4-usage-bar">
          <div class="v4-usage-bar-fill" [style.width.%]="wtOveragePercent"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<div class="section-wrapper" *ngIf="!isExternalBillingProvider && !isAppleBillingProvider"
  [ngClass]="{'subscription-plans': hasCreditCardOnFile && isUserOnTrialBasedBilling || !isUserOnTrialBasedBilling}">
  <div class="section-header d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center justify-content-between plans-header-wrapper">
      <div class="d-flex align-items-center"><ng-icon class="section-icon" [name]="'heroArrowsRightLeft'"
          [size]="'24px'" [color]="'#822AC6'" [strokeWidth]="'2'"></ng-icon>
        <div class="section-heading">
          {{ 'ACCOUNT.BILLING.PLANS_AND_PRICING' | translate }}
        </div>
      </div>
      <div class="billing-interval-toggle">
        <div class="billing-interval-option" (click)="selectInterval(SubscriptionInterval.Monthly)"
          [ngClass]="{'selected': selectedInterval === SubscriptionInterval.Monthly}">Pay Monthly</div>
        <div class="billing-interval-option" (click)="selectInterval(SubscriptionInterval.Yearly)"
          [ngClass]="{'selected': selectedInterval === SubscriptionInterval.Yearly}">Pay Annually
          <div class="billing-interval-badge"
            [ngClass]="{'selected': selectedInterval === SubscriptionInterval.Yearly}">2
            MONTHS FREE</div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!hasCreditCardOnFile && isUserOnTrialBasedBilling; else subscriptionPlans">
    <div class="section-content-wrapper trial-plans">
      <!-- ENG-2292: same plan picker as the Go Live step, with the API-recommended plan -->
      <rosie-choose-plan-section #choosePlanRef [recommendedPlan]="recommendedPlan" [hideIntervalToggle]="true"
        class="d-block mb-4"></rosie-choose-plan-section>
      <div class="cancel-trial-text d-flex align-items-center justify-content-center" *ngIf="!isInCancelState"
        [attr.data-subscription-id]="subscription.subscriptionData?.externalSubscriptionId"
        (click)="cancelSubscription()">
        Need to cancel? No problem, <span class="pointer underlined ml-xs"> click here to cancel your trial</span>.
      </div>
    </div>
  </ng-container>
  <ng-template #subscriptionPlans>
    <div class="section-info alert mb-0 align-items-center" *ngIf="isTestModeForBothBillingVersions">
      <div class="status-badge test mr-2">TEST MODE</div>
      <span class="text" *ngIf="isUserOnFreeMinutesBillingVersion">Add your credit card to activate your free trial and
        allow external
        calls.</span>
      <span class="text" *ngIf="isUserOn7DayFreeTrialVersion">Add your credit card to start accepting real customer
        calls.</span>

    </div>
    <div class="section-info custom" *ngIf="isEnterprisePlanSelected">
      <img class="icon" [src]="'assets/images/info-purple.svg'">
      <span class="text">You are currently on a custom plan. To change your subscription plan,
        reach out to <span class="pointer ml-0 text-underline" (click)="contactUs()">support.</span></span>
    </div>
    <div class="section-content-wrapper subscription-plans" *ngIf="!isEnterprisePlanSelected">
      <rosie-subscription-plans-checkout #checkoutRef [showIntervalSelectionCopy]="true"
        [hideIntervalToggle]="true"></rosie-subscription-plans-checkout>
      <rosie-all-plans-include *ngIf="!isUserOnBillingV4"></rosie-all-plans-include>
      <!-- <div class="terms-of-service-text" *ngIf="!isUserOnBillingV4">
        <span class="important">Minutes are unlimited</span> — but if usage suggests you need an enterprise contract, we
        may
        reach out. See our <a href='https://heyrosie.com/legal/terms' target='_blank' class='link'>Terms of Service </a>
        for
        limitations.
      </div> -->
      <rosie-all-plans-include *ngIf="isUserOnBillingV4"></rosie-all-plans-include>
    </div>
  </ng-template>
</div>

<div class="section-wrapper" *ngIf="isShopifyBillingProvider"
  [ngClass]="{'subscription-plans': true}">
  <div class="section-header">
    <ng-icon class="section-icon" [name]="'heroArrowsRightLeft'" [size]="'24px'" [color]="'#822AC6'"
      [strokeWidth]="'2'"></ng-icon>
    <div class="section-heading">
      {{ 'ACCOUNT.BILLING.PLANS_AND_PRICING' | translate }}
    </div>
  </div>
  <div class="section-content-wrapper subscription-plans">
    <rosie-subscription-plans-checkout [showIntervalSelectionCopy]="true" [hideIntervalToggle]="true"
      [changingPlanKey]="changingProviderPlanKey" (providerPlanSelected)="onProviderPlanSelected($event)">
    </rosie-subscription-plans-checkout>
    <rosie-all-plans-include></rosie-all-plans-include>
  </div>
</div>

<!-- Website Texting Modals -->
<rosie-website-texting-subscribe-modal #wtSubscribeModalRef
  (subscribed)="onWtSubscribed()"></rosie-website-texting-subscribe-modal>
<rosie-website-texting-cancel-modal #wtCancelModalRef
  (cancelled)="onWtCancelled()"></rosie-website-texting-cancel-modal>

<!-- Pause Subscription Modal -->
<rosie-pause-subscription-modal #pauseModalRef
  (paused)="onPaused()"></rosie-pause-subscription-modal>